import { useWorkspaceEmptyState } from '@/pages/company/WorkspaceRoute/hooks/useWorkspaceEmptyState';

import EmptyContainer from '@/pages/common/empty/components/EmptyContainer';

import noResults from '@/pages/common/empty/images/noResults.png';

const NoResult = () => {
  // DA-19732: one escape hatch for every narrowing the Workspace applies — global URL filter, doctype
  // tab, Inbox sub-type, grid column filters — cleared in a single batched commit by the hook.
  // Previously `link` received the reset useCallback FUNCTION itself, which only worked by accident of
  // react-router resolving a non-string `to` to the current pathname with the query dropped: the
  // doctype-tab segment survived the "reset" and the Redux sub-type filter was never touched.
  const { resetFilters } = useWorkspaceEmptyState();

  return (
    <EmptyContainer
      onClick={resetFilters}
      imageSrc={noResults}
      Icon={null}
      title={{ id: 'document.search.no_result', defaultMessage: 'No results found' }}
      description1={{
        id: 'document.search.no_document_decription_1',
        defaultMessage: "We can't find any document matching your search.",
      }}
      description2={{
        id: 'document.search.no_document_decription_2',
        defaultMessage: 'Please, try a different search.',
      }}
      buttonText={{
        id: 'document.search.no_document.reset_filters',
        defaultMessage: 'Reset filters',
      }}
    />
  );
};

export default NoResult;
